<template>
  <div>
    <h3>Import Price List - Budget Vals</h3>
    <button type="button" class="btn-danger" @click="maintenancePlanPriceUpload('Insurance Price Sheet')">
      Insurance Price Upload
    </button>
        <button type="button" class="btn-primary" @click="maintenancePlanPriceUpload('Maintenance Plan Price Sheet')">
      Maintenance Plan Price Upload
    </button>
  </div>
</template>

<script>
import {
    OPEN_ERROR_MODAL,
    PRICE_LIST_IMPORT
} from '@/vuex/types'
export default {
  name: 'PricingUpload',
  methods: {
    async maintenancePlanPriceUpload (priceUpload) {
      try {
        await this.$store.dispatch(PRICE_LIST_IMPORT, priceUpload)
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/PricingUpload.vue